export interface DateMonthYearValue {
  year: number;
  month: number;
  day: number;
}

const compareDates = (a: DateMonthYearValue, b: DateMonthYearValue) =>
  a.year === b.year && a.month === b.month && a.day === b.day;

export default compareDates;
